export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/abdf071c-cc16-48d1-9126-44724d759550.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/30c5fffc-d39e-4872-a535-2e3b663809c7.png',
};
